export const styles = {
  singleItemContainer: {
    position: 'relative',
    display: 'inline-flex',
  },
  multipleItemsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
  },
  extraCount: {
    marginLeft: '6px',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '150%',
    color: '#6E707A',
  },
};
